export const FILTER_ENUM = {
    AVAILABLE: 'available',
  };
